import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { createElementVNode as _$ce, createUnknownComponentVNode as _$cc, className as _$cn, noop as _$no, createVNode as _$cv } from 'intact-vue-next';
import { Transition, TransitionGroup, linkEvent } from 'intact-vue-next';
import { Checkbox } from '../checkbox';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { Icon } from '../icon';
import { Mode } from './useDraggable';
export default function ($props, $blocks, $__proto__) {
  var _this = this,
    _classNameObj2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    checkbox = _this$get.checkbox,
    showLine = _this$get.showLine,
    selectable = _this$get.selectable,
    draggable = _this$get.draggable;
  var expandedKeys = this.expanded.get();
  var toggleExpanded = this.expanded.toggle;
  var toggleChecked = this.checked.toggle;
  var selectedKeys = this.selected.get();
  var toggleSelected = this.selected.toggle;
  var _this$draggable = this.draggable,
    onDragStart = _this$draggable.onDragStart,
    onDragOver = _this$draggable.onDragOver,
    onDragEnd = _this$draggable.onDragEnd,
    draggingKey = _this$draggable.draggingKey,
    overKey = _this$draggable.overKey,
    mode = _this$draggable.mode;
  var k = this.config.k;
  var treeNodes = function treeNodes(nodes) {
    return _mapInstanceProperty(nodes).call(nodes, function (node, index) {
      var _classNameObj, _labelClassNameObj;
      if (!_filterInstanceProperty(node)) return;
      var key = node.key;
      var expanded = expandedKeys.has(key);
      var data = node.data;
      var disabled = data.disabled;
      var selected = selectable && selectedKeys.has(key);
      var classNameObj = (_classNameObj = {}, _classNameObj[k + "-tree-node"] = true, _classNameObj[k + "-expanded"] = expanded, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-selected"] = selected, _classNameObj[k + "-dragging"] = key === draggingKey.value, _classNameObj);
      var labelClassNameObj = (_labelClassNameObj = {}, _labelClassNameObj[k + "-tree-label"] = true, _labelClassNameObj[k + "-tree-leaf"] = !node.children, _labelClassNameObj);
      if (key === overKey.value) {
        switch (mode.value) {
          case Mode.Before:
            labelClassNameObj[[k + "-before"]] = true;
            break;
          case Mode.After:
            labelClassNameObj[[k + "-after"]] = true;
            break;
          case Mode.Inner:
            labelClassNameObj[[k + "-inner"]] = true;
            break;
        }
      }
      return _$ce(2, 'div', [_$ce(2, 'div', [node.children && node.loaded !== false ? _$cc(Icon, {
        'className': _$cn(k + "-tree-icon ion-android-arrow-dropdown"),
        'hoverable': true,
        'ev-click': function evClick(e) {
          // it may be in dropdownMenu, e.g. TreeSelect
          e._ignore = true;
          toggleExpanded(node);
        }
      }) : undefined, node.loaded === false ? _$cc(Icon, {
        'className': _$cn(k + "-tree-icon ion-load-c"),
        'rotate': true
      }) : undefined, checkbox ? _$cc(Checkbox, {
        'value': node.checked,
        'disabled': disabled,
        'indeterminate': node.indeterminate,
        'ev-$change:value': function ev$changeValue() {
          return toggleChecked(node);
        },
        'className': _$cn(k + "-tree-checkbox")
      }) : undefined, _$ce(2, 'div', (_$blocks['label'] = function ($super) {
        return data.label;
      }, __$blocks['label'] = function ($super, data) {
        var block = $blocks['label'];
        var callBlock = function callBlock() {
          return _$blocks['label'].call($this, $super, data);
        };
        return block ? block.call($this, callBlock, data) : callBlock();
      }, __$blocks['label'](_$no, [data, node, index])), 0, _$cn(k + "-tree-text c-ellipsis"), {
        'ev-click': linkEvent(node, _this.onClick)
      })], 0, _$cn(labelClassNameObj)), _$cc(Transition, _extends({}, _this.transition, {
        'children': expanded && node.children ? _$ce(2, 'div', _$cc(TransitionGroup, _extends({}, _this.transition, {
          'children': treeNodes(node.children)
        })), 2, _$cn(k + "-tree")) : undefined
      }))], 4, _$cn(classNameObj), {
        'draggable': draggable ? true : null,
        'ev-dragstart': draggable && linkEvent(node, onDragStart),
        'ev-dragover': draggable && linkEvent(node, onDragOver),
        'ev-dragend': draggable && onDragEnd
      }, key);
    });
  };
  var classNameObj = (_classNameObj2 = {}, _classNameObj2[k + "-tree"] = true, _classNameObj2[k + "-line"] = showLine, _classNameObj2[k + "-selectable"] = selectable, _classNameObj2[className] = className, _classNameObj2[makeStyles(k)] = true, _classNameObj2);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), _$cc(TransitionGroup, _extends({}, this.transition, {
    'children': treeNodes(this.nodes.getNodes())
  })));
}
;